

info = -> 
  SPAN 
    style: 
      paddingLeft: 3
      verticalAlign: 'middle'
    SVG 
      viewBox: "3 3 6.5915 6.5915"
      width: 15
      height: 15
      style: 
        display: 'inline-block'
        shapeRendering: 'geometricPrecision'
        textRendering: 'geometricPrecision'
        imageRendering: 'optimizeQuality'
        fillRule: 'evenodd'
        clipRule: 'evenodd'

      G 
        transform: "matrix(0.443852,0.000000,0.000000,0.443852,3.501380,3.501380)"
        PATH 
          fill: '#777'
          d: "M 6.29577,0 C 9.77228,0 12.59154,2.81926 12.59154,6.29577 C 12.59154,9.77228 9.77228,12.59154 6.29577,12.59154 C 2.81926,12.59154 0,9.77228 0,6.29577 C 0,2.81926 2.81926,0 6.29577,0 z M 7.241939,4.51008 L 7.241939,10.10704 L 7.988183,10.10704 L 7.988183,10.773334 L 7.854945,10.773334 L 4.603355,10.773334 L 4.603355,10.10704 L 5.349633,10.10704 L 5.349633,5.17637 L 4.603355,5.17637 L 4.603355,4.510076 L 4.736627,4.510076 L 7.241937,4.510076 L 7.241939,4.51008 z M 5.296309,2.75105 C 5.296309,2.511166 5.3829582,2.295734 5.556188,2.104718 C 5.729418,1.913702 5.953761,1.818211 6.229147,1.818211 L 6.362419,1.818211 C 6.593393,1.818211 6.806615,1.9026157 7.002052,2.071425 C 7.197523,2.2402 7.295224,2.466753 7.295224,2.75105 C 7.295224,2.990899 7.2108533,3.206332 7.042044,3.397348 C 6.873235,3.588364 6.646716,3.683855 6.362419,3.683855 L 6.229147,3.683855 C 5.998173,3.683855 5.784951,3.5994503 5.589514,3.430675 C 5.394043,3.261866 5.296308,3.035313 5.296308,2.75105 L 5.296309,2.75105 z "


styles += """
  [data-widget="Pricing"] ul.feature_matrix {
    list-style: none;
    padding-left: 32px;
  }

  [data-widget="Pricing"] ul.feature_matrix li {
    position: relative;

  }
  [data-widget="Pricing"] ul.feature_matrix li svg {
    position: absolute;
    left: -36px;
    top: 1px;
  }

  [data-widget="Pricing"] .plan_container {
    list-style: none;
    padding-top: 60px;
    display: flex;
    justify-content: center;
  }

  [data-widget="Pricing"] .plan {
    padding: 32px 36px;
    background-color: white;
    max-width: 420px;
    display: inline-block;
    margin: 0px 10px; 
    vertical-align: top;
    flex: 1 1 1;
  }

  [data-widget="Pricing"] .plan_name {
    font-weight: 800;
    text-align: center;
  }

  [data-widget="Pricing"] .plan_name_subtitle {
    font-style: italic;
    font-size: 16px;
    text-align: center;
  }

  [data-widget="Pricing"] .base_text {
    font-size: 16px;
    font-weight: 400;
  }

  [data-widget="Pricing"] .base_text.details_paragraph {
    padding-bottom: 30px;
    text-align: left
  }

  [data-widget="Pricing"] .base_text.plan_button {
    font-size: 18px;
    font-weight: 700;
    padding: 14px 12px;
    width: 100%;
    max-width: 300px;
    margin: auto;
    text-align: center;
    display: block;
    text-decoration: none;
  }

  [data-widget="Pricing"] .feature_matrix_item {
    margin-bottom: 12px;
  }

  [data-widget="Pricing"] .payment_container {
    padding-top: 0;
    text-align: center;
    display: none;
  }

  [data-widget="Pricing"] .money {
    font-size: 75px;
    font-weight: 800;
    line-height: 75px;
    position: relative;
  }

  [data-widget="Pricing"] .dollar {
    font-size: 32px;
    position: absolute;
    top: 10px;
    left: -20px;
    font-weight: 400;
  }

  @media (max-width: 414px) {
    [data-widget="Pricing"] .plan {
      padding: 32px 18px;
    }
  }

  @media (max-width: 1047px) {
    [data-widget="Pricing"] .plan_container {
      flex-direction: column;
    }
    [data-widget="Pricing"] .plan {
      margin: 20px auto;
      display: block;
      max-width: 600px;
      width: 95%;
    }
    [data-widget="Pricing"] .plan_name {
      font-size: #{responsive_css_rule({min_size: 24, max_size: 32, min_vw: 380, max_vw: 800})};
    }

  }

  @media (min-width: 1048px) {
    [data-widget="Pricing"] .plan_name {
      font-size: #{responsive_css_rule({min_size: 23, max_size: 32, min_vw: 1150, max_vw: 1400})};
    }
  

  }  
"""

window.Pricing = ReactiveComponent
  displayName: 'Pricing'

  render: -> 


    DIV 
      style: {}

      @heading()

      @plans()

      @consulting()

      # DIV style: paddingTop: 40, backgroundColor: 'white',
      #   @consultant_partnership()

      FAQ()

  heading: -> 
    DIV 
      style: 
        paddingTop: 40
        width: "var(--SAAS_PAGE_WIDTH)"
        margin: 'auto'
        textAlign: 'center'

      H1
        className: 'main_callout condensed'


        "Invest in your community’s opinions"

      DIV 
        style: 
          fontSize: responsive_css_rule({min_size: 16, max_size: 18, min_vw: 380, max_vw: 500})
          color: 'white'
          marginTop: 8

        'Careful organization and visualization of your stakeholders\' considered opinions'
        #'Your community\'s considered opinions, surfaced through pro/con deliberation, carefully organized and visualized'
        #'Try for as long as you want for free. Pay only when we help you engage your community.'

  plans: -> 

    region = bus_fetch('/application').region

    if region == 'EU'
      amount = "€655"
    else if region == 'CA'
      amount = "CA$1000"
    else 
      amount = "$750"

    free_features = [
      {label: "Unlimited Opinions & Comments", tooltip: "No limitations on the content you or participants can contribute."}
      {label: "Unlimited Participants & Hosts", tooltip: "No limitations on the number of people who can participate or act as a dialogue host."}
      {label: "Community Ideation", tooltip: "You can specify whether any participant is allowed to add new ideas to open-ended questions you pose."}
      {label: "Content Moderation", tooltip: "Select a moderation policy that fits the appropriate level of protection for your engagement."}
      {label: "Private Forum option", tooltip: "The forum can be set to private so that only people who have been invited can access the dialogue."}
      {label: "Customizable Banner", tooltip: "Welcome people to your forum! Set a title, add details, add a logo, and set a background image."}
      {label: "Google Translate Integration", tooltip: "Prominently feature a widget for helping participants select their preferred language."}
    ]


    premium_features = [
      {label: "Data Export", tooltip: "Export your forum data into CSV format. We can work with you if you have other data requirements. "}
      # {label: "Tabs for organizing your dialogue into different pages"}
      {label: "Sign-up questions for collecting demographics from participants", tooltip: "Collect relevant information from participants (e.g. demographics). You can create text, dropdown, and checklist type questions. This data can be used for comparing opinions between subgroups."}
      {label: "Opinion analytics for exploratory data analysis", tooltip: "Slice and dice the data to learn what different subgroups think! "}
      {label: "Tabs to organize your forum", tooltip: "Separate your topics into different pages to help structure your forum. You can even create an About page."}
    ]

    enterprise_features = [
      {label: "Dedicated engagement expert", tooltip: "We can work with you to craft your conversation, and assist in other ways that emerge."}
      {label: "Fully customized banner", tooltip: "If the built-in banner does not fit your forum vision, we can work with you to design one that does. <img style='margin-top: 12px' src='#{asset('product_page/customize_homepage.gif')}' width=300 />"}
      {label: "Coordinated data import", tooltip: "Sometimes you are trying to coordinate amongst multiple teams. We can help set up a process that steamlines collaborative data import into Consider.it."}
      # {label: "Custom data analysis"}
      {label: "Hosting at your web domain", tooltip: "By default, your forum will be hosted at e.g. https://myforum.consider.it. If you'd rather host it at your own domain at e.g. https://consider.gotham.gov, we've got you covered."}
      {label: "Single Sign-On (SSO)", tooltip: "We can work with you to implement Single Sign-On integration with your SAML-enabled identity provider."}
      {label: "Custom developed components", tooltip: "If there is some important but niche widget you need for your forum, like a zip-code filter, we can code and integrate it into your forum."}
      {label: "Service Level Agreement 2", tooltip: "99.5% Uptime Commitment. Guaranteed response to support requests within one business day, with escalation path to CEO available via text and email. Resolution of high severity issues guaranteed within one business day. Custom SLAs possible."}      

    ]

    UL
      className: 'plan_container'

      # FREE
      LI 
        className: 'plan'

        H2 
          className: 'plan_name'

          'Free Forum'
          #BR null
          #'Forum'

        DIV 
          className: 'plan_name_subtitle'

          'Use for as long as you wish'



        DIV 
          style: 
            paddingTop: 36
            paddingBottom: 60

          A 
            href: '/create_forum'
            target: '_blank'
            className: 'plan_button big_button base_text'
            'Create a Free Forum'        

        # DIV 
        #   style: _.defaults {}, payment_container_style, 
        #     display: if compact then 'none'
            

        #   SPAN 
        #     className: 'money'
        #     SPAN 
        #       className: 'dollar'
        #       '$'

        #     '0'

        P 
          className: 'base_text details_paragraph'
          """Engage as many stakeholders about any number of issues for as long as you 
             wish. Your forum can be public or private. No cost, no ads. Make as many free 
             forums as you want. You\'re welcome!"""


        UL 
          className: 'feature_matrix details_paragraph base_text'

          for feature in free_features
            LI 
              key: feature.label
              className: 'feature_matrix_item'

              checkmark(24, 'green')

              SPAN
                style: 
                  borderBottom: if feature.tooltip then "2px dotted #1d1c1d"
                "data-tooltip": if feature.tooltip then feature.tooltip
                feature.label            

          
      # paid
      LI 
        className: 'plan'


        H2 
          className: 'plan_name'

          'Premium Forum'

        DIV 
          className: 'plan_name_subtitle'

          "#{amount} one-time fee"




        DIV 
          style: 
            paddingTop: 36
            paddingBottom: 60

          A 
            href: '/create_forum?plan=premium'
            target: '_blank'
            className: 'plan_button big_button base_text'
            'Create a Premium Forum'        

        # DIV 
        #   style: _.defaults {}, payment_container_style, 
        #     display: if compact then 'none'
            

        #   SPAN 
        #     className: 'money'
        #     SPAN 
        #       className: 'dollar'
        #       '$'

        #     '625'

        P 
          className: 'details_paragraph base_text'
          """The full suite of Consider.it functionality. Export data, create demographic sign-up questions, \
             and organize your dialogue into different pages using tabs!"""


        P 
          style:
            fontStyle: 'italic'
            marginBottom: 24

          "Everything in a Free Forum, plus:"

        UL 
          className: 'feature_matrix details_paragraph base_text'

          for feature in premium_features
            LI 
              key: feature.label
              className: 'feature_matrix_item'

              checkmark(24, 'green')

              SPAN
                style: 
                  borderBottom: if feature.tooltip then "2px dotted #1d1c1d"
                "data-tooltip": if feature.tooltip then feature.tooltip
                feature.label            


      # ENTERPRISE
      LI 
        className: 'plan'

        H2 
          className: 'plan_name'

          'Enterprise Forum'

        DIV {},

          DIV 
            className: 'plan_name_subtitle'

            'Get help engaging your community'



        DIV 
          style: 
            paddingBottom: 60
            paddingTop: 36

          A 
            href: '/contact?form=upgrade_to_customized_forum'
            target: '_blank'
            className: 'plan_button big_button base_text'
            'Contact Us'        


        P 
          className: 'details_paragraph base_text'
          """We can help you design a dialogue to meet your goals, brand it, modify it as your community grows, and 
           assist with data analysis.
          """

        P 
          style:
            fontStyle: 'italic'
            marginBottom: 24

          "Everything in a Premium Forum, plus:"


        UL 
          className: 'feature_matrix details_paragraph base_text'

          for feature in enterprise_features
            LI 
              key: feature.label
              className: 'feature_matrix_item'

              checkmark(24, 'green')

              SPAN
                style: 
                  borderBottom: if feature.tooltip then "2px dotted #1d1c1d"
                "data-tooltip": if feature.tooltip then feature.tooltip
                feature.label            

        P 
          className: 'details_paragraph base_text'
          """Cost varies widely depending on requirements, timeline, budget, and mission.  
             Cost is usually between $3,500 and $12,500 for projects with minimal 
             procurement and no custom development."""


  consulting: -> 
    small_para_style = 
      fontSize: 16

    plan_button_style = _.extend {}, big_button(), 
      fontSize: 18
      fontWeight: 600
      padding: '10px 32px'
      textAlign: 'center'
      textDecoration: 'none'


    DIV 
      style: 
        backgroundColor: 'white'
        boxShadow: '0px -17px 27px 0px rgba(0,0,0,.14)'
        position: 'relative'
        zIndex: 1
        paddingTop: 50
        paddingBottom: 50

      A name: 'consulting'
      A name: 'testimonials'


      DIV 
        style: 
          maxWidth: "var(--SAAS_PAGE_WIDTH)"
          margin: '0 auto 40px auto'


        H2 
          className: 'bold_callout' 

          'Want help designing a conversation?'
          BR null
          ' Hire us to help with your forum.'

        DIV 
          style: 
            textAlign: 'center'
          A 
            href: '/contact?form=consulting_inquiry'
            target: '_blank'
            style: plan_button_style
            'Inquire about our consulting services' 


      DIV 
        style: 
          marginTop: 20
        TestimonialGrid
          testimonials: [testimonials.susie_pricing, testimonials.russ_pricing, testimonials.auryn_pricing]


      # TABLE 
      #   style: 
      #     margin: 'auto'

      #   TBODY null, 

      #     TR null, 

      #       TD null, 
      #         Testimonial 
      #           left: true 
      #           testimonial: testimonials.susie         

      #       TD null,

      #         DIV 
      #           style: 
      #             width: 400
      #             margin: 'auto'
      #             padding: '0px 40px'

      #           UL 
      #             style: 
      #               listStyle: 'outside'
      #               paddingLeft: 18
      #               marginBottom: 28
                  
      #             for service in [
      #                               'Process advice about your dialogue'
      #                               'Help creating clear and concise proposals'
      #                               'Training in Consider.it best practices'
      #                               'Creating new functionality for your forum' 
      #                             ]
      #               LI 
      #                 style: small_para_style
      #                 service


      #       TD null, 
      #         Testimonial 
      #           left: false 
      #           testimonial: testimonials.russ




  # consultant_partnership: -> 
  #   DIV 
  #     style: 
  #       backgroundColor: '#F4F4F4'
  #       borderTop:    '1px solid #B1B1B1'
  #       borderBottom: '1px solid #B1B1B1'
  #       padding: '36px 0 44px 0'

  #     A name: 'partnership'

  #     H2
  #       style: 
  #         fontWeight: 800
  #         color: 'black'
  #         fontSize: 24
  #         textAlign: 'center'
  #         color: '#303030'
  #         marginBottom: 14

  #       'Consultant Partnership'

  #     DIV 
  #       style: 
  #         fontSize: 16
  #         color: '#303030'
  #         maxWidth: 500
  #         margin: 'auto'

  #       "Are you a consultant? We "
  #       SPAN
  #         style: 
  #           color: '#EF3084'

  #       SVG 
  #         viewBox: "0 0 64 64" 
  #         width: 30
  #         height: 30
  #         style: 
  #           verticalAlign: 'bottom'

  #         G 
  #           fill: "#ff5a79"
  #           PATH
  #             d: "m28.3 32.2c1.3-7.9-11.5-20.7-22.3-10.3-12 11.7 7.2 37.1 8 40.1 2.6-.8 34.4-1.6 36-18.2 1.3-15.4-17.2-17.4-21.7-11.6"
  #           PATH 
  #             d: "m59.2 3.6c-6.8-5.1-13.1 3.1-11.7 7-3.3-2.9-13-.5-11.3 7.7 1.9 9.1 19.3 7.3 20.9 7.7.4-1.5 9.3-16.9 2.1-22.4"


  #       """ consultants. We offer special training and support for 
  #       consultants looking to use Consider.it with their clients, as well as 
  #       access to pricing incentives you can pass onto clients. Please """
  #       A 
  #         href: '/contact?form=consultant_partnership'
  #         style: 
  #           textDecoration: 'underline'
  #         "introduce yourself"
  #       "."




styles += """
  .embedded p {
    margin-bottom: 12px;
  }

  .embedded emph {
    font-style: italic;
  }

  .embedded strong {
    font-weight: 700;
  }
  .embedded a {
    text-decoration: underline;
  }

  .embedded ul { padding-top: 20px; padding-left: 18px; list-style: outside;}

  .embedded li { padding-bottom: 12px; }


  [data-widget="FAQ"] .faq_col {
    display: inline-block;
    width: 48%;
    padding: 0 20px;
    vertical-align: top;
  }

  @media (max-width: 1000px) {
    [data-widget="FAQ"] .faq_col {
      display: block;
      width: 100%;
      margin-top: 48px;
    }
  }

  [data-widget="FAQ"] .faq {
    font-weight: 700;
    font-size: #{responsive_css_rule({min_size: 16, max_size: 20, min_vw: 414, max_vw: 500})};
    margin-bottom: 12px;
  }

  @media (max-width: 500px) {
    [data-widget="FAQ"] {
      display: none;
    }
  }

"""

FAQ = ReactiveComponent
  displayName: 'FAQ'
  render: -> 

    DIV 
      style: 
        backgroundColor: 'white'
        padding: '80px 40px 140px 40px'
      A name: 'faq'
      DIV  
        style: 
          margin: 'auto'
          maxWidth: 1100

        for set in [['Tech Questions',tech_qs], ['Pricing Questions', pricing_qs]]
          header = set[0]
          question_set = set[1]

          DIV 
            key: header
            className: "faq_col"

            H2
              className: 'bold_callout' 
              style: 
                margin: '0px 0px 20px 0px'

              header

            UL 
              style: 
                listStyle: 'none'

              for faq in question_set 
                LI 
                  key: faq.q
                  style: 
                    marginBottom: 20

                  A name: faq.l if faq.l

                  H3
                    className: 'faq'
                    faq.q 

                  DIV 
                    style: 
                      fontSize: 16
                      color: '#303030'

                    DIV 
                      className: 'embedded'
                      dangerouslySetInnerHTML: {__html: faq.a}
                        


tech_qs = [
  {
    l: 'customization'
    q: """How can I brand my forum and give it my organization’s look and feel?"""
    a: """The Free Forum has a template for customizing to your brand that works for most cases. 
          If you need something more customized, <a href="/contact">contact us</a> and we can talk about
          what you need. We can fully customize to your brand, such as 
          <a href="https://mofo-impact-goal.consider.it" target="_blank">this forum for the Mozilla Foundation</a>."""
  }
  {
    l: 'profile_questions'
    q: """I want to know more about participants in my forum. Can I ask about their age? Race & ethnicity? If they’re a renter or homeowner? If they’re a board member?"""
    a: """With the Premium Forum you can configure sign-up questions. These questions are asked of participants after they create an account.  
          This information can then be used to cross tabulate the results to explore the opinions of segments of your stakeholders. 
          It is also available in the data export."""
  }  
  {
    l: 'civility'
    q: """Can we moderate the forum and maintain civil discourse?"""
    a: """Yes. As a forum host, you have a number of options for hiding incivil and/or off-topic user 
          posts. We’ve found an even more powerful mechanism though: a participation pledge that all participants in your forum 
          will need to agree to when creating an account. It is amazing what setting expectations can do. 
          Overall, <a href="/tour#research">we have found</a> the structure of our forums to lend themselves to civil discourse. We have hosted 
          municipal dialogues on very contentious issues without having to moderate a single comment."""
  }
  {
    l: 'access_control'
    q: """Can I make my forum invite-only so only certain people can access it?"""
    a: """Yes. Once you create your forum you will be able to set the forum as private. Then only people who you invite can participate in the forum. You can set user roles to give people view-only access or the ability to respond. Furthermore, you can make specific questions invite-only."""
  }
  {
    l: 'translation'
    q: """Do you offer forums in languages other than English?"""
    a: """Yes. First, Google Translate can be enabled in the banner of any forum.  
          This is a good option for multi-lingual forums. 
          Second, we have created a way for anyone to contribute interface translations for non-English languages. 
          This can provide a higher quality experience for communities whose members’ primary language isn’t English. 
          <a href="/contact">Contact us if your language isn't available yet</a>.
          Third, sometimes clients wish to create clones of a forum in order to target different languages. 
          If you've paid for an Premium Forum for one language, we are happy to upgrade the other language forums at no cost.
          """
  }
  {
    l: 'mobile'    
    q: """Does Consider.it work on mobile?"""
    a: """Yes. It is responsive and works on most mobile devices. We do not currently offer a stand alone mobile app."""
  }

  {
    l: 'accessibility'
    q: """Is Consider.it compliant with accessibility standards?"""
    a: """Yes, Consider.it is <a href='https://www.w3.org/WAI/intro/wcag.php'>WCAG</a> Level A compliant. <a target="_blank" href='https://docs.google.com/document/u/2/d/e/2PACX-1vS5-8UQlzGYY5Su38VDUXDbiAy2S72ZARfU8-Xmi-Nxo5vvXN9HkV_W6zXYF6o-2UM5cHuR4FvTdR1N/pub'>Learn more</a>."""
  }
  {
    l: 'vanity_url'    
    q: """Can I use a custom URL? Can I host the forum on my own server?"""
    a: """We can set up your forum to use a custom URL. At this time, we do not support self-hosting on your own server. """
  }
  {
    l: 'saml'    
    q: """Do you support SAML single sign-on?"""
    a: """We have a limited implementation. Contact us to help determine if it fits your needs."""
  }
  {
    l: 'comparison'    
    q: """How is this different than a survey or a web forum?"""
    a: """<p>Some people think of a Consider.it forum as a combination of a survey and a forum. See <a href="/tour#comparison_guide" target="_blank">our comparison guide</a>.</p>"""
  }

]

per_opinion = 
  l: 'pay_per_opinion'    
  q: """What counts as an opinion? Why do you charge "per opinion" in the paid plans?"""
  a: """<p style='padding-bottom:8px'>An opinion is collected when someone slides and saves their position on a question in your forum. Pro/con points are not counted.</p> 
        <div style='text-align:center'>
          <img width='90%' src='#{asset('product_page/opinions_count.png')}'>
          <p style='padding-bottom:8px;font-style:italic'>27 opinions</p>
        </div>
        <p style='padding-bottom:8px'>We charge per opinion because it is fair to you 
        – you pay only when you’re getting value from our service – 
        and fair to us – we get compensated for a fraction of the value we provide you. 
        Small communities pay less. You don't pay during periods of inactivity.</p> 
        <p>For comparison, the opinions collected at <a href='https://wsffn.consider.it' target='_blank'>https://wsffn.consider.it</a> that led to an adopted strategic plan cost $1200.</p>"""

pricing_qs = [
  {
    l: 'free_forum'    
    q: """Tell me about the Free Forum. What's the catch?"""
    a: """No catch. You can <a href='/create_forum'>create</a> as many free forums as you wish and use them for as long as you want. 
          Your forums are public by default, but you can make them invite-only. 
          At any point, you can upgrade a forum to the Premium Plan to access several <a href='/tour#features'>premium features</a> like data export, 
          sign-up questions, and tab-based organization."""
  }
  {
    l: 'budget'
    q: """How much can I expect to pay for an Enterprise forum?"""
    a: """This depends on the engagement, your organization's size, and its mission. Engagements that run for several weeks to months with heavy customization typically end up between $2,000 and $5,000."""
  }
  {
    l: 'consultant_partnership'    
    q: """I’m a consultant and want to set up forums for multiple clients. Can you help me? """
    a: """Yes. We work with consultants all the time. We can help you customize forums for each of your clients, or create a branded look for your consulting firm. <a href="/contact?form=consultant_partnership">Get in touch</a> and we can talk. """
  }
  {
    l: 'demo'    
    q: """Can I speak with someone about the plan options and get a demo?"""
    a: """Absolutely! We’re happy to <a href="/contact?form=request_demo">set up a time to talk</a>."""
  }
  {
    l: 'discount'    
    q: """I want to use Consider.it for an innovative project that will benefit society but can’t afford the price. Can you offer a discount? """
    a: """Possibly! We take organization size and mission into account in our budgeting process. Please <a href="/contact">contact us</a> to talk."""
  }
  # {
  #   l: 'cancelation'    
  #   q: """Can I cancel my plan at any time?"""
  #   a: """Yes. You can either close your forum and stop collecting opinions or contact us to delete your forum entirely."""
  # }
  {
    l: 'refunds'    
    q: """What is your refund policy?"""
    a: """We don’t offer refunds on the setup fee if the work has already been done. If you feel we have made an error in billing or haven’t provided the service we promised, please let us know and we'll work with you to create a fair resolution."""
  }
  {
    l: 'invoice'    
    q: """Can you issue invoices and receive checks instead of a credit card? """
    a: """Yes. Please <a href="/contact">contact us</a>."""
  }

]






/** WEBPACK FOOTER **
 ** ../wwwconsiderit/@client/product_page/pricing.coffee
 **/